import { Button } from '@/components/ui/button'

interface ErrorPageAction {
  label: string
  onClick: () => void
  variant?: 'default' | 'outline' | 'destructive'
}

interface ErrorPageProps {
  statusCode?: number
  title: string
  description: string
  actions: ErrorPageAction[]
}

export function ErrorPage({
  statusCode,
  title,
  description,
  actions,
}: ErrorPageProps) {
  return (
    <div className='flex h-full items-center justify-center p-6 m-auto'>
      <div className='w-full max-w-md space-y-6 text-center'>
        <div className='space-y-2'>
          {statusCode && (
            <p className='text-5xl font-bold text-muted-foreground/50'>
              {statusCode}
            </p>
          )}
          <h1 className='text-2xl font-bold'>{title}</h1>
          <p className='text-muted-foreground'>{description}</p>
        </div>

        <div className='flex flex-col justify-center gap-3 sm:flex-row'>
          {actions.map((action) => (
            <Button
              key={action.label}
              variant={action.variant ?? 'default'}
              onClick={action.onClick}
            >
              {action.label}
            </Button>
          ))}
        </div>
      </div>
    </div>
  )
}
